import { render, staticRenderFns } from "./IndiviDualAssessment.vue?vue&type=template&id=78c51bfc&"
import script from "./IndiviDualAssessment.vue?vue&type=script&lang=js&"
export * from "./IndiviDualAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports